<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-29 15:13:52
 * @LastEditors: luckymiaow
-->

<script lang="ts" setup>
import { useAttrs, useSlots } from 'vue';
import useForm from '../../form/src/useFormConfig';
import type { EnumSelectProps } from '../types';
import { Select } from '../../select';
import useSlot from '../../hooks/useSlot';
import useEnum from './useEnum';

interface Props extends EnumSelectProps {
  enum: object;
  /* 排除选项的枚举值 */
  excludeOptions?: any[];
  /* 指定选项的枚举值 */
  appointOptions?: any[];
}

const props = defineProps<Props>();

const { options } = useEnum({ props });

const { getBindValue } = useForm<EnumSelectProps>({ props, componentName: 'EnumSelect', attrs: useAttrs() });

const { useExcludeSlots } = useSlot({ slots: useSlots() }, []);
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <Select v-bind="getBindValue" :options="options">
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </Select>
</template>
